const Paddle = window.Paddle;
export const getTrailSubscription = (schoolId) => {
    Paddle.Checkout.open({
        product: 578748,
        quantity:10,
        passthrough: { schoolId: schoolId },
        successCallback: (data, err) => {
            let message = undefined;
            if (data.completed) {
                message = 'Payment SuccessFul'
            } else {
                message = 'Payment Failed'
            }
            return {
                showPaymentNotifier: true,
                message: message
            }
        }
    });
};